import { SxProps } from '@mui/material'
import { GrainImage } from '@/assets'

interface BannerAnimatedStyles {
  /**
   * Fills the banner section; sits below all content via z-index -1
   * */
  wrapper: SxProps

  /**
   * Base canvas for the animation
   */
  canvas: SxProps

  /**
   * Hidden SVG that registers the noise filter definition for the DOM
   * */
  noiseSvg: SxProps

  /**
   * Grain texture layer blended over the canvas — starts invisible and fades in
   * */
  noiseOverlay: SxProps

  /**
   * Applied once the animation starts to fade the grain in.
   * Opacity is lower on mobile — high-DPR screens render grain more prominently.
   */
  noiseOverlayVisible: SxProps

  noiseFilter: SxProps

  /**
   * Tiling grain image overlay — starts invisible, fades to 0.4 when animation starts
   * */
  grainImage: SxProps

  /**
   * Applied once the animation starts to fade the grain image in.
   */
  grainImageVisible: SxProps
}

export const bannerAnimatedStyles: BannerAnimatedStyles = {
  wrapper: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: -1,
    pointerEvents: 'none',
  },
  canvas: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    transform: 'scale(1.3)',
    transition:
      'opacity 2.5s cubic-bezier(0.25,0.1,0.25,1), transform 2.5s cubic-bezier(0.25,0.1,0.25,1)',
  },
  noiseSvg: {
    display: 'none',
    position: 'absolute',
    width: 0,
    height: 0,
  },
  noiseOverlay: {
    display: 'none', // just keeping this around for reference — we use the grain image instead of the filter for better performance and visual quality
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    pointerEvents: 'none',
    opacity: 0,
    mixBlendMode: 'overlay',
    transition: 'opacity 2s ease',
  },

  noiseOverlayVisible: {
    opacity: { xs: 1, lg: 0.8 },
    transitionDelay: '0.5s',
  },
  noiseFilter: {
    width: '100%',
    height: '100%',
    filter: 'url(#banner-gradient-noise)',
  },
  grainImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    visibility: 'hidden',
    backgroundImage: `url(${GrainImage})`,
    backgroundRepeat: 'repeat',
    backgroundSize: '100px 100px',
    mixBlendMode: 'darken',
    transition: 'opacity 2s ease',
  },
  grainImageVisible: {
    opacity: 0.4,
    visibility: 'visible',
  },
}
